module.exports = __webpack_public_path__ + "img/collectomate-logo.d391316e.png";